export default "__VITE_ASSET__Cx4iK1v9__"